//@flow
//Action Type Registered
export const EROS_INV_SUBMIT_SUCCESS='EROS_INV_SUBMIT_SUCCESS';
export const EROS_INV_SUBMIT_ERROR='EROS_INV_SUBMIT_ERROR';
export const EROS_INV_SUBMITTED_COMPLETED='EROS_INV_SUBMITTED_COMPLETED';
export const EROS_EDIT_VERIFY_FORM_DATA_SUCCESS='EROS_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const EROS_EDIT_VERIFY_FORM_DATA_ERROR='EROS_EDIT_VERIFY_FORM_DATA_ERROR'
export const EROS_UPDATE_FORM_ERROR='EROS_UPDATE_FORM_ERROR'
export const REFRESH_EROS_VENDORS_SUCCESS='REFRESH_EROS_VENDORS_SUCCESS';
export const REFRESH_EROS_VENDORS_ERROR='REFRESH_EROS_VENDORS_ERROR';


// WEBPACK FOOTER //
// ./src/redux/eros/actionTypes.js